export default __webpack_public_path__ + "static/media/Logo-02.ea0cd074.png";